import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

export enum MessageType {
  INFO = 'info', // eslint-disable-line
  WARNING = 'warning', // eslint-disable-line
  ERROR = 'error', // eslint-disable-line
}

type InputMessageProps = {
  text: string;
  type: MessageType;
};

const MESSAGE_TYPE_CLASS = {
  [MessageType.INFO]: 'text-muted',
  [MessageType.WARNING]: 'text-warning',
  [MessageType.ERROR]: 'text-danger',
};

const InputMessage: FC<InputMessageProps> = ({
  text,
  type = MessageType.INFO,
}) => {
  const { t } = useTranslate();

  return (
    <span className={`sub-text ${MESSAGE_TYPE_CLASS[type]}`}>
      <i>{t(text)}</i>
    </span>
  );
};

export default InputMessage;
